import { Link } from 'react-router';
import { useLearner } from '@/app/useAppState';
import { SubjectBadge } from '@/components/ui/Badges';
import { ScreenHeader } from '@/components/ui/ScreenHeader';
import { curriculum } from '@/content/curriculum';
import { useI18n } from '@/i18n/context';
import { cn } from '@/lib/cn';

export function SubjectsScreen() {
  const learner = useLearner();
  const { t, l } = useI18n();
  const subjects = curriculum.subjectsFor(learner.levelId);
  return (
    <div className="flex flex-col gap-6">
      <ScreenHeader title={t('subjects.title')} />
      {subjects.length === 0 && <p className="text-ink-muted">{t('subjects.none')}</p>}
      <ul className="grid gap-4 sm:grid-cols-2">
        {subjects.map((subject) => {
          const count = curriculum.objectivesFor(
            subject.id,
            learner.levelId,
            learner.variantId,
          ).length;
          return (
            <li key={subject.id}>
              <Link
                to={`/learn/subjects/${subject.id}`}
                className={cn(
                  `subject-${subject.color}`,
                  'flex items-center gap-4 rounded-[var(--radius-card)] bg-[var(--subject-soft)] p-5 transition-transform hover:-translate-y-0.5',
                )}
              >
                <SubjectBadge subject={subject} size="lg" />
                <span className="flex flex-col">
                  <span className="text-xl font-extrabold text-ink">{l(subject.name)}</span>
                  <span className="text-sm font-bold text-[var(--subject-ink)]">
                    {t('subjects.objectives', { count })}
                  </span>
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
